<template>
  <div class="carousel-wrapper">
    <div class="carousel-viewport">
      <div class="carousel-track" :style="trackStyle">
        <CardItem
          v-for="(card, i) in cards"
          :key="i"
          :title="card.title"
          :active="i === activeIndex"          
        > 
          <slot name="card-content" :card="card"></slot>
        </CardItem>
      </div>
    </div>     

    <div class="carousel-nav">
      <button class="nav-btn" @click="prev">
        <IconPrev />
      </button>
      <slot name="nav-center"></slot>
      <button class="nav-btn" @click="next">
        <IconNext />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import CardItem from './CardItem.vue'
import IconPrev from '@/assets/icons/IconPrev.vue'
import IconNext from '@/assets/icons/IconNext.vue'

@Component({ components: { CardItem, IconPrev, IconNext } })
export default class CarouselSection extends Vue {
  @Prop() cards!: { title: string; lines: { text: string }[]; icons: (typeof Vue)[] }[]

  activeIndex = 1
  cardsVisible = 3
  
  get trackStyle() {
    
    if (!this.cards || this.cards.length === 0) {
      return { transform: 'translateX(0px)' }
    }

    const cardWidth = 290
    const gap = 14
    const totalCards = this.cards.length
    const visible = this.cardsVisible

    if (this.activeIndex === 0) {
    const fixedOffset = 356   
    return { transform: `translateX(${fixedOffset}px)` }
    }

    else if (this.activeIndex === totalCards - 1) {
    const fixedOffset = -663  
    return { transform: `translateX(${fixedOffset}px)` }
    }

    let startIndex = 0

    if (totalCards <= visible) {
      startIndex = 0
    }
    
    else if (this.activeIndex === totalCards - 1) {
      startIndex = totalCards - 2 
    } else {
      
      startIndex = Math.min(this.activeIndex - 1, totalCards - visible)
    }

    const offset = -(cardWidth + gap) * startIndex

    return {
      transform: `translateX(${offset}px)`
    }
  }

  prev() {
    if (this.activeIndex > 0) {
      this.activeIndex--
    }
  }

  next() {
    if (this.activeIndex < this.cards.length - 1) {
      this.activeIndex++
    }
  }
}
</script>

<style scoped>
.carousel-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1032px;
}

.carousel-viewport {
  width: 1032px;
  overflow-x: hidden;
  padding-top: 60px;
}

.carousel-track {
  display: flex;
  gap: 14px;
  transition: transform 0.35s;
}

.card {
  width: 290px;
  flex-shrink: 0;
}

.carousel-nav {
  display: flex;  
  justify-content: center;
  align-items: center;
  margin-top: 56px;
}

.nav-btn {
  background: none;
  border: none;
  cursor: pointer;
}
</style>
